<ng-container>
  <location-selector [properties]="properties"></location-selector>
</ng-container>
